<template>
  <div class="details-expanded">
    <el-row type="flex" :gutter="8" class="mt-20">
      <el-col :span="10">
        <el-row type="flex">
          <el-col :span="24">
            <h5 class="display-block" style="color:#000000">Login Anomaly</h5>
            <span class="subtitle2">
              {{ details.description }}
            </span>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="9" class="mt-10">
        <el-row type="flex">
          <el-col :span="24">
            <h5 class="display-block" style="color:#000000">
              Potential Impact
            </h5>
            <span class="subtitle2" v-if="details.anomalyDetails">
              {{ details.anomalyDetails.potentialImpact }}
            </span>
          </el-col>
        </el-row>
        <el-row type="flex" class="mt-10">
          <el-col :span="24">
            <h5 class="display-block" style="color:#000000">
              Recommendation(s)
            </h5>
            <span class="subtitle2" v-if="details.anomalyDetails">
              {{ details.anomalyDetails.recommendation }}
            </span>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4">
        <el-tooltip class="item" content="Investigate this anomalous detection." placement="top" :enterable="false">
          <el-button class="add-button" size="small" @click="gotoThreatHunting(details, 'user')">
            View Activity in Threat Hunting
          </el-button>
        </el-tooltip>
      </el-col>
    </el-row>
    <el-row type="flex" class="mt-30">
      <el-col :span="24" v-loading="loadingAnomalyDetails">
        <h5 class="display-block" style="color:#000000">
          Summary of new logins for the last day
        </h5>
        <basic-table-element
          v-if="!loadingAnomalyDetails"
          :columns="anomalyDetails.columns"
          :table-data="anomalyDetails.collection"
          :height-offset="300"
          ref="anomalyLoginTable"
        ></basic-table-element>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import BasicTableElement from '@/components/table/BasicTableElement.vue'
import BarChartJs from '@/components/chart/BarChartJs.vue'
import expandedAnomalyDetectionMixin from '@/components/expand/expandedAnomalyDetectionMixin'

export default {
  name: 'ExpandNewLoginAnomalyDetails',
  mixins: [expandedAnomalyDetectionMixin],
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      detectionType: 'login',
      loadingAnomalyDetails: false,
      chartOptions: {
        layout: {
          padding: {
            left: 25
          }
        },
        title: {
          display: true,
          text: 'Login Anomalies'
        },
        tooltips: {
          enabled: true
        },
        scales: {
          xAxes: [
            {
              offset: true,
              type: 'time'
            }
          ]
        },
        legend: {
          display: false
        },
        subtitle: 'Count'
      }
    }
  },
  methods: {},
  created () {
    if (this.details.anomalyMetadata.drillDownResult.drillDownTemplate) {
      this.detectionType = this.details.anomalyMetadata.drillDownResult.drillDownTemplate
    }
    if (this.details.uid && _.isEmpty(this.details.anomalyDetails)) {
      this.loadAnomalyDetails()
    }
  },
  components: {
    BarChartJs,
    BasicTableElement
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.details-expanded {
  padding: 20px;
  background: var(--aluminum-200);
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #d7dbe0;
  background-color: #f8fcff;
}

.material-icons {
  font-size: 1.3em;
  line-height: 36px;
  vertical-align: middle;
  color: var(--gray-500);
  background: transparent;
}

.el-divider--vertical {
  margin: 0px;
}

>>> .el-button {
  /* background-color: var(--aluminum-800); */
  color: white;
  border-radius: 3px;
  background-color: #77dab4;
  margin-bottom: 20px;
  height: 40px;
  width: auto;

  a {
    text-decoration: none;
    color: white;
  }
}

.footer-buttons {
  &.center {
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/expand/ExpandNewLoginAnomalyDetails.vue